import { GlobalThemeConfiguration } from '@finxone-platform/shared/sys-config-types';
import { GlobalThemeStateModel } from '../state/global-theme.state';

export class GetProjectThemes {
  static readonly type = '[GlobalThemeState] GetProjectThemes';
  constructor(public projectId: string) {}
}

export class UpdateProjectThemes {
  static readonly type = '[GlobalThemeState] UpdateProjectThemes';
  constructor(public projectId: string) {}
}

export class ResetThemesConfig {
  static readonly type = '[GlobalThemeState] ResetThemesConfig';
  constructor(public projectId: string) {}
}

export class UpdateActiveThemeConfig {
  static readonly type = '[GlobalThemeState] UpdateActiveThemeConfig';
  constructor(public themeConfig: GlobalThemeConfiguration) {}
}

export class AddNewGlobalThemeConfig {
  static readonly type = '[GlobalThemeState] AddNewGlobalThemeConfig';
  constructor(public themeConfig: GlobalThemeConfiguration, public setAsActiveTheme = true) {}
}

export class SetActiveTheme {
  static readonly type = '[GlobalThemeState] SetActiveTheme';
  constructor(public themeName: string) {}
}

export class UpdateGlobalThemeState {
  static readonly type = '[GlobalThemeState] UpdateGlobalThemeState';
  constructor(public globalThemeState: GlobalThemeStateModel) {}
}
